import logo from "./assets/kangaroo/logo.svg";
import "./App.css";
import Homepage from "./Homepage/Homepage";
import {
  BrowserRouter,
  Navigate,
  Route,
  Router,
  Routes,
} from "react-router-dom";
import JoinSuccess from "./Homepage/JoinSuccess";

import Page3 from "./Homepage/LearnMore";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/kangaroo.css";
import "./assets/fonts/fonts.css";
import MainLayout from "./page/Layout/MainLayout";

import About from "./pages/AboutPage/page/About";
import TestPreparation from "./pages/TestPreparationPage/page/TestPreparation";
import Ielts from "./pages/IeltsPage/page/Ielts";
import InstitutionPage from "./pages/InstitutionPage/page/InstitutionPage";
import CountryPage from "./pages/CountryPage/page/CountryPage";
import AboutLanding from "./pages/AboutPage/page/AboutLanding";
import InstitutionRepresent from "./pages/InstitutionWeRepresent/page/InstitutionRepresent";
import Destination from "./pages/DestinationPage/page/Destination";
import CareerLanding from "./pages/CareerPage/page/CareerLanding";
import ScrollToTop from "./component/ScrollTop/ScrollToTop";
import AboutPartner from "./pages/AboutPage/page/AboutPartner";
import AboutMilestone from "./pages/AboutPage/page/AboutMilestone";
import CareerDetail from "./pages/CareerPage/page/CareerDetail";
import Blog from "./pages/BlogPage/page/Blog";
import BlogLanding from "./pages/BlogPage/page/BlogLanding";
import Event from "./pages/EventPage/page/Event";
import EventDetail from "./pages/EventPage/page/EventDetail";
import Franchise from "./pages/FranchisePage/page/Franchise";
import Contact from "./pages/ContactPage/page/Contact";
import Getfreecounseling from "./pages/GetFreeCounseling/page/Getfreecounseling";
import FranchiseHidden from "./pages/FranchisePage/page/FranchiseHidden";
import Professional from "./Homepage/Professional";
import Professional2 from "./Homepage/Professiona2";
import Visa from "./pages/VisaMigration/page/Visa";
import Tax from "./pages/TaxReturn/page/Tax";
import OshcPage from "./pages/OSHC/page/OshcPage";
import ServicePage from "./pages/ServicePages/page/ServicePage";
import PageDetails from "./page/PageTypeTheme/PageDetail";
import ThemeDetail from "./page/Theme/ThemeDetail";
import Privacy from "./pages/PrivacyPage/page/Privacy";
import AustralianVisaCalculator from "./pages/Calculator/pages/VisaEligibility";
import SkillSelectCalculator from "./pages/Calculator/SkillSelectCalculator";
import CostOfLivingCalculator from "./pages/Calculator/CostOfLivingCalculator";
import PrPointCalculator from "./pages/Calculator/PrPointCalculator";
import SkilledMigrationCalculator from "./pages/Calculator/SkilledMigrationCalculator";
import VisaEligibleCalculator from "./pages/Calculator/VisaEligibleCalculator";
import Testimonial from "./pages/TestimonialPage/page/Testimonial";
import ImmiAccountGuide from "./pages/Calculator/pages/CreateImmi";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Homepage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/freecounseling" element={<Getfreecounseling />} />
          <Route path="/about/ceo" element={<About />} />
          <Route path="/about/who-we-are" element={<AboutLanding />} />
          <Route path="/about/partner" element={<AboutPartner />} />
          <Route path="/about/milestone" element={<AboutMilestone />} />
          <Route
            path="/quick-links/institution-we-represent"
            element={<InstitutionRepresent />}
          />
          <Route path="/services" element={<Destination />} />
          <Route path="/corporate/career" element={<CareerLanding />} />
          <Route
            path="/corporate/career/:jobTitle"
            element={<CareerDetail />}
          />
          <Route path="/testpreparation" element={<TestPreparation />} />
          <Route path="/blog" element={<BlogLanding />} />
          <Route path="/events" element={<Event />} />
          <Route path="/corporate/franchise" element={<Franchise />} />
          <Route
            path="/corporate/franchisehidden"
            element={<FranchiseHidden />}
          />
          <Route path="/events/:eventID" element={<EventDetail />} />
          <Route path="/blog/:id" element={<Blog />} />
          <Route path="/testprep/:section" element={<Ielts />} />
          <Route path="/innerpage/:section" element={<CountryPage />} />
          <Route path="/services/visa" element={<Visa />} />
          <Route path="/services/taxreturn" element={<Tax />} />
          {/* <Route path="/services/oshc" element={<OshcPage />} /> */}
          <Route path="/services/:section" element={<ServicePage />} />
          <Route path="/institution/:slug" element={<InstitutionPage />} />
          <Route path="/privacy/:id" element={<Privacy />} />

          {/* <Route path="/australian-visa-calculator" element={<AustralianVisaCalculator/>} /> */}
          <Route
            path="/useful-links/skillselect-visa-pr-point-calculator"
            element={<SkillSelectCalculator />}
          />
          <Route
            path="/useful-links/cost-of-living-calculator"
            element={<CostOfLivingCalculator />}
          />
          <Route
            path="/useful-links/australia-pr-points-calculator"
            element={<PrPointCalculator />}
          />
          <Route
            path="/useful-links/create-immiaccount"
            element={<ImmiAccountGuide />}
          />
          <Route
            path="/useful-links/skilled-migration-points-calculator"
            element={<SkilledMigrationCalculator />}
          />
          <Route path="/quick-links/testimonial" element={<Testimonial />} />
          <Route
            path="/useful-links/australian-visa-eligibility-calculator"
            element={<VisaEligibleCalculator />}
          />
          {/*   CMS / MENU BASED PAGES — MUST BE LAST */}
          <Route path="/:slug" element={<PageDetails />} />
          <Route path="/:slug/:page" element={<ThemeDetail />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
